import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../makeup/makeup_area/MakeupArea.module.sass';
import Button from '../../../../ui_kit/button/Button';
import BackButton from '../../back_button/BackButton';
import Block from '../../makeup/makeup_area/block/Block';
import BODY_CATEGORIES from '../../../constants/body_categories';

function BodyArea(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const [area, setArea] = useState(quiz.productType.split(' - ')[0]);
  const detailedProductType = quiz.productType.split(' - ').slice(1).join(' - ');

  const productType = `${area} - ${area === quiz.productType.split(' - ')[0] ? detailedProductType : ''}`;

  const onNextClick = () => {
    increaseStep({ ...quiz, productType });
  };

  const { color } = quiz;

  return (
    <>
      <BackButton
        decreaseStep={() => { decreaseStep({ ...quiz, productType }); }}
      />
      <div className={styles['makeup-area']}>
        <div className={styles.content}>
          {step}
          <div className={styles.title}>
            Which body area fits your idea’s criteria?
          </div>
          <div className={styles.description}>
            Choose one.
          </div>
          <div className={styles.areas}>
            <Block
              text={BODY_CATEGORIES.FULL_BODY}
              active={area === BODY_CATEGORIES.FULL_BODY}
              onClick={() => { setArea(BODY_CATEGORIES.FULL_BODY); }}
              color={color}
            />
            <Block
              text={BODY_CATEGORIES.HANDS}
              active={area === BODY_CATEGORIES.HANDS}
              onClick={() => { setArea(BODY_CATEGORIES.HANDS); }}
              color={color}
            />
            <Block
              text={BODY_CATEGORIES.FACE}
              active={area === BODY_CATEGORIES.FACE}
              onClick={() => { setArea(BODY_CATEGORIES.FACE); }}
              color={color}
            />
            <Block
              text={BODY_CATEGORIES.LEGS}
              active={area === BODY_CATEGORIES.LEGS}
              onClick={() => { setArea(BODY_CATEGORIES.LEGS); }}
              color={color}
            />
            <Block
              text={BODY_CATEGORIES.UNDERARMS}
              active={area === BODY_CATEGORIES.UNDERARMS}
              onClick={() => { setArea(BODY_CATEGORIES.UNDERARMS); }}
              color={color}
            />
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={!area}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

BodyArea.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    productType: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default BodyArea;
